import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Comercializacion } from './comercializaciones.model';

export const entityComercializacionesAdapter: EntityAdapter<Comercializacion> =
  createEntityAdapter<Comercializacion>({
    selectId: (model) => model.id,
    sortComparer: (a: Comercializacion, b: Comercializacion): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityComercializacionesState extends EntityState<Comercializacion> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityComercializacionesState =
  entityComercializacionesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
